<template>
  <div id="final" ref="element">
    <img class="final-logo" src="../assets/intro-logo.png" />
    <p class="final-text final-text-1">
      We all have the right, the responsibility, and the opportunity to change the world for 
      the better. Even though we’re facing different global challenges, by making small changes 
      and opening up the dialogue, we can each make a big difference and help save our relationship 
      with food, the planet, and the people who we share them with. 
    </p>
    <div class="social-share-wrap">
      <p class="social-share-title">
        Now let the other people know:
      </p>
      <div class="social-buttons-wrap">
        <div class="social-button">
          <ShareNetwork
            network="twitter"
            :url="
              $i18n.locale === 'it' ?
              'https://wethefoodtheplanet.org/it/'
              : 
              'https://wethefoodtheplanet.org/en/'
            "
            title="We, the food, the planet"
            :description="
              $i18n.locale === 'it' ?
              descriptionIta:
              descriptionEng
            "
          >
            <img src="../assets/social-share/twitter.svg" />
          </ShareNetwork>
        </div>
        <div class="social-button">
          
          <ShareNetwork
            network="facebook"
            :url="
              $i18n.locale === 'it' ?
              'https://wethefoodtheplanet.org/it/'
              : 
              'https://wethefoodtheplanet.org/en/'
            "
            title="We, the food, the planet"
            :description="
            $i18n.locale === 'it' ?
            descriptionIta:
            descriptionEng
            "
          >
            <img src="../assets/social-share/facebook.svg" />
          </ShareNetwork>
        </div>
        <div class="social-button">
          <a href="mailto:?subject=We,%20the%20food,%20the%20planet&body=https://wefood-prototype.netlify.app/" target="_blank">
            <img src="../assets/social-share/mail.svg" />
          </a>
        </div>
      </div>
    </div>
    <p class="final-text final-text-2"
      v-html="
        $i18n.locale === 'it' ?
        `Resta aggiornato sulle scelte più efficaci da compiere per migliorare le nostre vite 
        (tra cui ricette sane e raccomandazioni da me, il tuo solo e unico pianeta) consultando e salvando <a href='https://www.sueatablelife.eu' target='_blank'>il link di suetablelife project</a>`
        :
        `Stay up to date on the best choices to better our lives, including healthy recipes and recommendations 
        from me, your one and only planet, by checking out and saving and saving <a href='https://www.sueatablelife.eu' target='_blank'>the suetablelife project link</a>`
        "
      
    ></p>
  </div>
</template>

<script>

import {gsap} from 'gsap'

import {ShareNetwork} from 'vue-social-sharing'

export default {
  name: 'FinalChat',
  props: ['start'],
  components:{
    ShareNetwork
  },
  data(){
    return {
      descriptionEng: "The planet would like to speak with you...are you ready to listen? See how you can help solve global environmental and health issues through the food you eat by having a quick chat with planet Earth!",
      descriptionIta: "Il pianeta vorrebbe parlarti… sei pronto/a ad ascoltare? Scopri come puoi contribuire a risolvere i problemi ambientali e sanitari globali grazie al cibo che mangi facendo due chiacchiere con il pianeta Terra!"
    }
  },
  methods:{
    startTransition(){
      let imgLogoHeight = this.$refs.element.querySelector('.final-logo').offsetHeight;
      this.$store.dispatch('triggerScrollWindow', imgLogoHeight); 
      
      
      var TL = gsap.timeline({delay: 1});
      TL
      .to('.final-logo', {opacity: 1, duration: .75})
      .to('.final-text-1', {opacity: 1, duration: .75})
      .to('.social-share-wrap', {opacity: 1, duration: .75})
      .to('.social-button', {opacity: 1, stagger: 0.1, duration: .75})
      .to('.final-text-2', {opacity: 1, duration: .75})
    }
  },
  mounted(){
    this.startTransition()
  },
  
}
</script>

<style lang="scss">
  #final {
    position: relative;
    width: 100%;
    .final-logo{
      margin-left: 0;
      width: 50%;
      opacity: 0;
      margin-top: 60px;
    }
    p{
      color: #fff;
      font-size: 24px;
      line-height: 32px;
      &.final-text{
        margin-bottom: 32px;
        opacity: 0;
      }
      a {
        color: inherit;
        text-decoration: underline;
      }
    }
    .social-share-wrap{
      position: relative;
      margin-left: 0;
      margin-bottom: 40px;
      opacity: 0;
      p{
        font-weight: 700;
        margin-bottom: 24px;
      }
      .social-buttons-wrap{
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .social-button{
          background-color: #2E70E2;
          padding: 28px 40px;
          border: 2px solid #3C4F9B;
          display: flex;
          align-items: center; 
          justify-content: center;
          opacity: 0;
          border-radius: 5px;
          margin: 0 5px;
          align-self: stretch;
          &:nth-child(1){
            margin-left: 0;
          }
        }
        @media screen and (max-width: 768px) {
          .social-button{
            padding: 15px;
            a,img{
              width: 30px;
              display: block;
            }
          }
        }
      }
    }
  }
</style>